import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { State } from '../../model'
import * as actions from '../../model/projects/actions'

import Layout, { IProps as LayoutProps } from './Layout'

import {
  Project,
  UnsavedProjectType,
  isSavedProject,
} from '../../interfaces/entities/project'
import { ProjectsFilter } from '../../interfaces/services/projects'

import DI from '../../app/di'
import { translateWithUserLocale } from '../../utils/i18n'

import { toast } from 'react-toastify'

const { useEffect } = React

const Main = (props: LayoutProps) => {
  useEffect(() => {
    props.getProjects(null)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return <Layout {...props} />
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getProjects: (filter: ProjectsFilter | null) =>
      dispatch(actions.getProjects(filter)),
    onProjectSave: (
      project: Project | UnsavedProjectType,
      meta: { created: boolean },
    ) => {
      toast.success(translateWithUserLocale('project_modal.save_success'))
      if (meta.created && isSavedProject(project)) {
        const history = DI.get('history')
        history.push(`/project/${project.id}`)
      }
      return dispatch(actions.saveProject(project))
    },
  }
}

const mapStateToProps = (state: State) => {
  return { page: state.projects, user: state.user }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
